import React from 'react';
import ReactMarkdown from 'react-markdown';
import * as styles from './Callout.module.css';

export interface CalloutProps {
  title: string;
  content: string;
}

const Callout: React.FC<CalloutProps> = ({ title, content }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.body}>
        <ReactMarkdown
          components={{
            ul: ({ children }) => <ul className={styles.list}>{children}</ul>,
            li: ({ children }) => <li className={styles.listItem}>{children}</li>,
          }}
        >
          {content}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default Callout;
